import React from 'react'
import Button from 'react-bootstrap/Button'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
const ToolTipForButton = ({ overlay, text, Cmp }) => {
    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {overlay}
        </Tooltip>
    )
    return (
        <OverlayTrigger
            placement="bottom"
            delay={{ show: 0, hide: 0 }}
            overlay={renderTooltip}
        >
            {Cmp}
        </OverlayTrigger>
    )
}

export default ToolTipForButton
